import { Mail } from 'lucide-react';
import { CONTACT } from '../config/constants';

const EmailButton = ({ className = 'btn btn-white btn-lg' }) => (
  <a href={`mailto:${CONTACT.email.general}`} className={className}>
    <Mail size={20} />
    {CONTACT.email.general}
  </a>
);

export default EmailButton;
